import {
  Component,
  OnInit,
  ViewEncapsulation,
  forwardRef,
  SimpleChanges
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import {
  tap,
  switchMap,
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter
} from 'rxjs/operators';

import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { Company } from 'src/app/domains/companies/models';
import { CompaniesService } from 'src/app/domains/companies/services';

@Component({
  selector: 'gdp-company-search',
  templateUrl: './company-search.component.html',
  styleUrls: ['./company-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanySearchComponent),
      multi: true
    }
  ],
  // had to turn off encapsulation to override ng-bootstrap and ladda styles
  encapsulation: ViewEncapsulation.None
})
export class CompanySearchComponent implements OnInit, ControlValueAccessor {
  public searching: boolean = false;
  public company: Company | null;
  public isListEmpty: boolean;
  public disabled: boolean;

  constructor(
    private companiesService: CompaniesService,
    private notification: NotificationService
  ) { }

  ngOnInit() { }
  // Form control stuff
  private onChange = (_: any) => { };
  private onTouch = () => { };
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  writeValue(c: Company): void {
    if (c) {
      this.company = c;
    } else {
      this.company = null;
    }
  }
  companySelected(e: NgbTypeaheadSelectItemEvent) {
    this.onChange(e.item);
  }
  onModelChange(event: any) {
    if (!event) {
      this.onChange(null);
    }
  }
  setDisabledState(state: boolean) {
    this.disabled = state;
  }

  // Typeahead stuff
  public resultFormatter = (result: Company) => `${result.name} (${result.alphaname})`;
  public companySearch = (text$: Observable<string>) => {
    return text$.pipe(
      filter(v => v.length >= 2),
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => {
        this.searching = true;
        this.isListEmpty = false;
      }),
      switchMap(
        term =>
          this.companiesService.getCompaniesBySearch(term).pipe(
            catchError(() => {
              return of([]);
            })
          )
      ),
      tap((result: Company[]) => {
        this.searching = false;
        this.isListEmpty = result.length === 0;
      })
    );
  }

}
